export default function updateFilters(state, filters) {
  return { ...state, filters };
}
